import { render, staticRenderFns } from "./LeadsModal.vue?vue&type=template&id=3277c6d2"
import script from "./LeadsModal.vue?vue&type=script&lang=js"
export * from "./LeadsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports